import { createStore, createLogger } from 'vuex'
import login from './module/login'
import user from './module/user'
import message from './module/message'
import project from './module/project'
import tabPage from './module/tabPage'
import database from './module/database'
import gisFile from './module/gisFile'
import localFile from './module/localFile'
import scene from './module/scene'
import cooperation from './module/cooperation'
import sceneStyle from './module/sceneStyle'
import databaseStyle from './module/databaseStyle'
import sceneResult from './module/sceneResult'
import sceneRun from './module/sceneRun'
import tile from './module/tile'

import modelManage from './module/modelManage'
import rapidModel from "./module/rapidModel";
import modelBuild from "./module/modelBuild";
import modelUpload from "./module/modelUpload";
import modelAdvanced from "./module/modelAdvanced";
import modelComparison from "./module/modelComparison";
import userCenter from "./module/userCenter";
import subscriptionManage from './module/subscriptionManage'
import dante from './module/dante'

const debug = process.env.NODE_ENV != 'production'

export default createStore({
    modules: {
        login,
        user,
        message,
        project,
        tabPage,
        database,
        modelManage,
        rapidModel,
        gisFile,
        localFile,
        scene,
        cooperation,
        scene,
        sceneStyle,
        databaseStyle,
        sceneResult,
        sceneRun,
        tile,
        modelBuild,
        modelUpload,
        modelAdvanced,
        modelComparison,
        userCenter,
        subscriptionManage,
        dante
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})